import styled from 'styled-components';
import { rem } from 'polished';
var Details = styled.div.withConfig({
  displayName: "Details",
  componentId: "traspy-0"
})(["align-items:center;display:flex;flex-flow:row wrap;padding:", " 0;"], rem(8));
export default Details;